import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";

import { CreateUploadFlashcardsComponent } from "./create-upload-flashcards.component";
import { UploadStepComponent } from "./upload-step/upload-step.component";
import { FlashcardsCheckStep } from "./flashcards-check-step/flashcards-check-step.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { CoreModule } from "src/app/core/core.module";
import { TablerIconComponent } from "angular-tabler-icons";
import { TabsButtonsComponent } from "../../../shared/tabs-buttons/tabs-buttons.component";
import { TextStepComponent } from "./text-step/text-step.component";
import { FlashcardsPreview } from "./flashcards-preview/flashcards-preview.component";
// import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

@NgModule({
  declarations: [
    CreateUploadFlashcardsComponent,
    UploadStepComponent,
    FlashcardsCheckStep,
    TextStepComponent,
    FlashcardsPreview
  ],
  imports: [
    CommonModule,
    FormsModule,
    PdfViewerModule,
    // NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    TranslateModule,
    ControlsModule,
    SharedModule,
    CoreModule,
    TablerIconComponent,
    TabsButtonsComponent
],
  exports: [
    CreateUploadFlashcardsComponent
  ]
})
export class CreateUploadFlashcardsModule {}